// src/components/components/NewRouteLoader.jsx

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import "./NewRouteLoader.css"; // ✅ Ensure this path is correct
import circle from "../../media/aspenseparated/circle.svg";

const NewRouteLoader = () => {
  const location = useLocation();
  const previousPath = useRef(location.pathname);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (location.pathname === previousPath.current) return;

    previousPath.current = location.pathname;
    NProgress.start();
    setShow(true);

    const timeout = setTimeout(() => {
      NProgress.done();
      setShow(false);
    }, 600);

    return () => clearTimeout(timeout);
  }, [location]);

  if (!show) return null;

  return (
    <div className="route-loader-overlay">
      <img src={circle} alt="Loading" className="route-loader-img" />
    </div>
  );
};

export default NewRouteLoader;
